import { render, staticRenderFns } from "./RefsHandover.vue?vue&type=template&id=1620cba8"
import script from "./RefsHandover.vue?vue&type=script&lang=ts"
export * from "./RefsHandover.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports